import {useState} from 'react';
import { Table, Button, Box, Typography, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton, Tooltip,InputAdornment } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { NoRecordFound } from '../../shared_elements';
import { regexConstants } from '../../constants/regEx';
import { labelMap } from '../reserve_rate/components';
import { exportToExcel } from '../../utils/helper';
import { numberWithCommas } from '../../utils';
import ImportModal from './ImportModal';

const CustomRatioDerateTable = ({ onMultiFieldChange, onMultiDelete, modeType, ratioDerateData, onAddMultiRow,rateBasedOn,error,onFocusChange,excelData,setExcelData,onImportExcel, handleItemClicked }) => {
  const [importDetails, setImportDetails] = useState({ modal: false, data: null })
  let headerArr
  if (rateBasedOn === 9) {
    headerArr = ["Ratio", `Rate${ratioDerateData?.interval?.label ? `/${ratioDerateData?.interval?.label}` : "" }*`, 'Action']
  } else {
    headerArr = ["DeRate",`Rate${ratioDerateData?.interval?.label ? `/${ratioDerateData?.interval?.label}` : "" }*`, 'Action']
  }
  if (modeType === "view") {
    headerArr = headerArr?.filter(ele => ele !== "Action")
  }
  const isButtonEnabled = [ 9, 11].includes(rateBasedOn) ? !ratioDerateData?.interval?.value || !ratioDerateData?.allow_decimal?.value || !ratioDerateData?.rounding?.value : rateBasedOn === 10 ? !ratioDerateData?.interval?.value || !ratioDerateData?.allow_decimal?.value  : false;
  const samplePayload = { reserve_rate_based_on : rateBasedOn, interval: ratioDerateData?.interval?.value  || null, }
  const requiredHeaders = [ rateBasedOn === 9 ?  "ratio" : "derate", "rate"];  
  const headerMap = { ratio: "ratio", derate: "derate", rate: "rate", [`rate/${ratioDerateData?.interval?.label?.toLowerCase()}`]: "rate", };
  const transformExcelData = (data) => {
    return data.map((row) => {
      const rateValue = String(row["rate"] || "").replace(/[^0-9.]/g, "");
      return {
        type: rateBasedOn,
        rate: Number(rateValue) || 0,
        ...(rateBasedOn === 9 ? { ratio: row.ratio } : { derate: row.derate })
      };
    });
  };
  const validateExcelData = (rows) => {
    const dynamicKey = rateBasedOn === 9 ? "ratio" : "derate";
    const allowedDecimal = Number(ratioDerateData?.allow_decimal?.value  || 0);
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const value = row[dynamicKey];
      const rate = String(row["rate"] || "").replace(/[^0-9.]/g, "");
      if ( value === undefined || value === "" || value === null || !rate ) {
        return `Invalid data at row ${i + 2}. Please follow sample format.`;
      }
      const stringValue = String(value);
      if (stringValue.includes(".")) {
        const decimalPart = stringValue.split(".")[1];
        if (decimalPart.length > allowedDecimal) { return `${rateBasedOn === 9 ? "Ratio" : "DeRate"} at row ${ i + 2 } allows maximum ${allowedDecimal} decimal place${ allowedDecimal > 1 ? "s" : "" }.`; }
      }
      if (rate.includes(".")) {
        const rateDecimal = rate.split(".")[1];
        if (rateDecimal.length > 2) { return `Rate at row ${i + 2} allows maximum 2 decimal places.`; }
      }
    }
    return null;
  };
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography className='section-header-text'>{labelMap[rateBasedOn]}</Typography>
        <Box sx={{ display: "flex", alignItems: "center", }}>
          <>
          <Button disabled={isButtonEnabled || modeType === "view"} onClick={() => { setImportDetails({ modal: true }); handleItemClicked?.('Import Button') }}>Import</Button>
            <Button sx={{ pointerEvents: !ratioDerateData?.interval_condition?.length ? "not-allowed" : "pointer" }} disabled={!ratioDerateData?.interval_condition?.length || isButtonEnabled}
              onClick={() => { exportToExcel({
                data: ratioDerateData?.interval_condition,
                fileName: `${rateBasedOn === 9 ? "FH_FC" : "DeRate"}_Based_Ratio_Table`,
                sheetName: `Ratio Table`,
                columns: {
                  [rateBasedOn === 9 ? "Ratio" : "DeRate"]: (row) => `${rateBasedOn === 9 ? row?.ratio : row?.derate}`,
                  [`Rate${ratioDerateData?.interval?.label ? `/${ratioDerateData?.interval?.label}` : ''}`]: (row) => `${ratioDerateData?.currency?.symbol || "$"} ${row.rate}`,
                }
              }); handleItemClicked?.('Export Button') }}>Export</Button>
          </>
        </Box>
      </Box>
      <TableContainer component={Paper} className="scrollable-table rental-scrollable-table-container">
        <Table size="small" className="mui-table-format" stickyHeader>
          <TableHead>
            <TableRow>
              {headerArr?.map((header, idx) => (
                <TableCell
                  key={idx}
                  className={idx === 0 ? 'nowrap-cell range-header' : idx === 2 ? 'sticky-action-header' : 'nowrap-cell'}
                >
                  <b>{header}</b>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {ratioDerateData?.interval_condition?.length > 0 && ratioDerateData?.interval_condition?.map((row, index) => (
              <TableRow key={index}>
                <TableCell >
                  <TextField
                    defaultValue={0}
                    value={rateBasedOn === 9 ? row?.ratio : row?.derate}
                    size="small"
                    onChange={(e) => { regexConstants.decimalNoDotStartWithVariables(ratioDerateData?.allow_decimal?.value).test(e.target.value) ? onMultiFieldChange("interval_condition", index, rateBasedOn === 9 ? 'ratio' : "derate", e.target.value) : e.preventDefault() }}
                    disabled={modeType === "view"}
                    slotProps={{
                      htmlInput: {
                        maxLength: 11,
                      }
                    }}
                    error={!!error[`row_${index}`]  || false}
                    helperText={error[`row_${index}`] || ""}
                    onFocus={() => onFocusChange(`row_${index}`)}
                  />
                </TableCell>
                <TableCell >
                  <TextField
                    defaultValue={0}
                    value={modeType === "view" && row?.rate !== undefined && row?.rate !== "" ? numberWithCommas(Number(row.rate).toFixed(2)) : row.rate}
                    size="small"
                    onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? onMultiFieldChange("interval_condition", index, 'rate', e.target.value,) : e.preventDefault() }}
                    disabled={modeType === "view"}
                    slotProps={{
                      htmlInput: {
                        maxLength: 11,
                      },
                      input: { startAdornment: (<InputAdornment position="start">{ratioDerateData?.currency?.symbol}</InputAdornment>) }
                    }}
                    error={!!error[index] || false}
                    helperText={error[index] || ""}
                    onFocus={() => onFocusChange(index)}
                  />
                </TableCell>
                {modeType !== "view" ? <TableCell className="sticky-action-cell" sx={{ p: 0 }}>
                  <Tooltip title="Delete">
                    <IconButton size="small" color="error" onClick={() => { onMultiDelete("interval_condition", index); handleItemClicked?.('Delete Row Icon') }}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                </TableCell> : null}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {ratioDerateData?.interval_condition?.length === 0 && <NoRecordFound />}
      {modeType !== 'view' ? <Button
        sx={{ marginTop: 1 }}
        variant='outlined'
        className='btn-primary'
        disabled={modeType === 'view'} size='small'
        onClick={() => { onAddMultiRow(rateBasedOn); handleItemClicked?.(rateBasedOn === 9 ? 'Add Ratio Button' : 'Add DeRate Button') }}
      >
        {rateBasedOn === 9 ? "Add Ratio" : "Add DeRate"}
      </Button> : null}
      {importDetails?.modal ? <ImportModal
        requiredHeaders={requiredHeaders}
        headerMap={headerMap}
        transformExcelData={transformExcelData}
        validateExcelData={validateExcelData}
        sampleExportName={`Sample_${rateBasedOn === 9 ? "FH_FC" : "DeRate"}_Based_Ratio_Table`}
        excelData={excelData}
        setExcelData={setExcelData}
        importDetails={importDetails}
        onImportExcel={onImportExcel}
        samplePayload={samplePayload}
        onToggleModal={() => setImportDetails({ modal: false, data: null })}
        handleItemClicked={handleItemClicked} /> : null}
    </>

  );
};
export default CustomRatioDerateTable;
